import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-portGroup",
  "use": "app-icon-portGroup-usage",
  "viewBox": "0 0 17 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 14\" id=\"app-icon-portGroup\"><path stroke=\"#99A3B2\" d=\"M4.186 11.549H1V3.334h2.242V1h6.87v2.127\" /><path d=\"M6.27 9.282h1.507v1.506H6.27zM9.283 9.282h1.506v1.506H9.283zM12.294 9.282H13.8v1.506h-1.506z\" /><path d=\"M13.8 4.765v-2.26H6.27v2.26H4.013V13.8h12.047V4.765H13.8zm1.318 8.094H4.953V5.706H7.21V3.447h5.648v2.259h2.259v7.153z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol